<template>
  <div class="ContactMap wow bounceInUp">
    <img
      class="map"
      src="../../assets/img/contactus/map.jpg"
      alt=""
      @click="openMap"
    />

    <div class="box_amap wow bounceInRight" data-wow-delay="0.6s">
      <div class="m_name">联系我们</div>
      <div class="main">
        <p class="b_icon_phone">统一服务热线 ：020-83523942</p>
        <p class="b_icon_web">网址：gztjssws.com</p>
        <p class="b_icon_email">邮箱：office@gztjssws.com</p>
        <p class="b_icon_address">地址：广州市越秀区文德路67号金德大厦9楼</p>
      </div>
      <div class="m_time">
        <p class="b_icon_time">工作时间：周一至周五(09:00-18:00)</p>
        <p>欢迎来电咨询！</p>
      </div>
    </div>
  </div>
</template>

<script>
// import VueAMap from "vue-amap";
// let amapManager = new VueAMap.AMapManager();
export default {
  name: "ContactMap",
  data() {
    return {
      center: [113.271734, 23.122637],
      zoom: 20, //缩放级别
      // amapManager,
      // windowOpen: true,
      icon_marker: require("../../assets/img/contactus/icon_callout.png"),
      position_marker: [113.271734, 23.122637],
      offset_marker: [-52, -106],
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: true,
      }).init();
    });
  },
  methods: {
    openMap() {
      window.open(
        "https://map.baidu.com/poi/%E5%B9%BF%E5%B7%9E%E7%BB%9F%E8%AE%A1%E5%B8%88%E4%BA%8B%E5%8A%A1%E6%89%80/@12610196.965,2630699.25,19z?uid=626d02dad664fc00057ce864&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.ContactMap {
  width: 100%;
  min-width: $themeMinWidth;
  height: 432px;
  position: relative;
  padding: 20px 0 50px;
  .info-window-content {
    position: relative;
  }
  .map {
    width: 100%;
    display: block;
    height: 432px;
    object-fit: cover;
    cursor: pointer;
  }
  .box_amap {
    width: 327px;
    height: 376px;
    background-color: #ffffff;
    box-shadow: 2px 3px 7px 0px rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 47px;
    left: 50%;
    margin: 0 0 0 264px;
    box-sizing: border-box;
    padding: 40px 30px;
    z-index: 6;
    &::before {
      content: "";
      display: block;
      width: 8px;
      height: 30px;
      background-color: #406cdd;
      position: absolute;
      top: 40px;
      left: 0;
    }
    .m_name {
      font-size: 20px;
      line-height: 30px;
      font-weight: bold;
      color: #000000;
      padding: 0 0 10px 0;
    }
    .main {
      border-top: dashed 1px #3e3e3e;
      border-bottom: dashed 1px #3e3e3e;
      padding: 10px 0;
    }
    .m_time {
      padding: 10px 0 0 0;
    }
    p {
      font-size: 14px;
      line-height: 30px;
      color: #000000;
      padding: 0 0 0 34px;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        top: 5px;
        left: 0;
      }
      &.b_icon_email::before {
        background: url("../../assets/img/contactus/b_icon_email.png") no-repeat;
        background-size: contain;
      }
      &.b_icon_phone::before {
        background: url("../../assets/img/contactus/b_icon_phone.png") no-repeat;
        background-size: contain;
      }
      &.b_icon_web::before {
        background: url("../../assets/img/contactus/b_icon_web.png") no-repeat;
        background-size: contain;
      }
      &.b_icon_address::before {
        background: url("../../assets/img/contactus/b_icon_address.png")
          no-repeat;
        background-size: contain;
      }
      &.b_icon_time::before {
        background: url("../../assets/img/contactus/b_icon_time.png") no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>
